import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { images } from 'theme'
import { path } from 'utils/const'
import Login from './Login'
import Signup from './Signup'
import ResetPassword from './ResetPassword'
import styles from './auth.module.scss'

const Auth = () => (
  <div className={styles.authRoot}>
    <div className={styles.leftContainer}>
      <div className={styles.logo_header}>
        <img src={images.logo} className={styles.logo} alt="logo" />
        <span className={styles.title}>
          Free Online Doctor Consultation 24/7
        </span>
      </div>
      <div className={styles.illustrationDocDiv}>
        <img src={images.illustrationDoc} alt="illustration doc" />
      </div>
    </div>
    <div className={styles.rightContainer}>
      {/* <div className={styles.innerRightContainer}> */}
      <Login />
      {/* </div> */}
    </div>
  </div>
)

export default Auth

// <Switch>
//         <Route path={path.login}>
//           <Login />
//         </Route>
//         <Route path={path.signup}>
//           <Signup />
//         </Route>
//         <Route path={path.resetPassword}>
//           <ResetPassword />
//         </Route>
//         <Redirect to={path.login} />
//       </Switch>
